export enum NotificationDeliveryWindow {
    STANDARD = 'STANDARD',
    TIMEZONE = 'TIMEZONE',
    INFORMED = 'INFORMED',
    HOLD_OUT = 'HOLD_OUT',
}
